import styled from "styled-components";
import Loading from "../../Assets/Loading.svg";

export const TableWrapper = styled.div`
  display: flex;
  width: 100%;
  /* justify-content: center; */
  margin: 0 auto;
`;

export const Table = styled.table`
  width: 100%;
  /*max-width: 94%;*/
  margin: 0;
  overflow-x: scroll;
  min-width: 1500px;
`;


export const TableBody = styled.tbody`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
  /* overflow-x: scroll; */
`;

export const TableHead = styled.thead`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  padding: 5px 0;
  border-bottom: 1px solid #e1dede;
`;

export const TopHeaderRow = styled.tr`
  /* width: 100%; */
  display: flex;
  margin: 0 auto 1rem 20rem;
  justify-content: space-evenly;
`;

export const TopTableHeader = styled.th`
  display: flex;
  justify-content: flex-start;
  color: #777777;
  height: auto;
  padding: 0 2rem;
`;

export const HeaderRow = styled.tr`
  width: 400px;
  display: flex;
  padding: 0 0px;
`;

export const TableHeader = styled.th`
  display: flex;
  justify-content: flex-start;
  color: #777777;
  height: auto;
`;

export const TransRow = styled.tr`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e1dede;
  padding: 10px 0px;
`;

export const TransTd = styled.td`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  vertical-align: middle;
  align-items: center;
  margin-left: 0rem;
  color: #777777;
  font-size: 15px;
`;

export const ModalHeaderWrapper = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  margin: 4rem 2rem 0;
  vertical-align: middle;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 2rem 2rem 0;
    text-align: center;
  }

  p {
    margin: 2rem 0;
  }
`;

export const ModalBlurbWrapper = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  margin: 0rem 2rem 0;
  vertical-align: middle;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 2rem 2rem 0;
    text-align: center;
  }

  p {
    margin: 2rem 0;
  }
`;

export const ModalRow = styled.tr`
  width: 100%;
  display: flex;
  border-bottom: 1px solid #e1dede;
  border-top: 1px solid #e1dede;
  padding: 10px 0px;
  /* margin-top: 2rem; */
`;

export const ModalTd = styled.td`
  width: 90%;
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
  align-items: center;
  margin-left: 0rem;
  color: #777777;
  font-size: 15px;
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: flex-start;
  margin: 1rem 0rem;
`;

export const ConfirmButton = styled.button`
  background-color: #1572de;
  width: ${({ date }) => (date ? "95px" : "150px")};
  height: 30px;
  border-radius: 4px;
  font-size: 15px;
  outline: none;
  border: none;
  cursor: pointer;
  margin: ${({ date }) => (date ? "0rem 1rem" : "0 0 0 4rem")};
  color: white;
  :hover {
    background-color: #0c55ab;
    transition: ease 0.2s;
  }

  :active {
    border: 1px solid #d6d6d6;
    border-radius: 4px;
  }
`;

export const DenyButton = styled.button`
  background-color: #bf3131;
  width: 200px;
  height: 30px;
  border-radius: 4px;
  font-size: 15px;
  outline: none;
  border: none;
  cursor: pointer;
  color: white;

  :hover {
    background-color: #962727;
    transition: ease 0.2s;
  }

  :active {
    border: 1px solid #d6d6d6;
    border-radius: 4px;
  }
`;

export const UnrecoModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  margin: 4rem 4rem 0;
  vertical-align: middle;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 2rem 2rem 0;
    text-align: center;
  }

  p {
    margin: 2rem 0;
  }
`;

export const TransCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 1.2rem;
  height: 1.2rem;
  background-color: #67be23;
  cursor: pointer;
  :input::checked {
    background-color: #67be23;
  }
`;

export const CheckContainer = styled.label`
  display: block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
`;

export const CheckboxBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin: 3px 4px;
  cursor: pointer;
  z-index: 10;
  width: 1rem;
  height: 1rem;
  background: ${({ selected }) => (selected ? "transparent" : "#67be23")};
  border: .5px solid #e1e1e1;
`;

export const ConfirmWrapper = styled.div`
  width: 100%;
  height: 8rem;
`;

export const ConfirmHeaderWrapper = styled.div`
  display: flex;
  margin: 1rem 0rem 0;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  vertical-align: middle;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 2rem 4rem 0;
    text-align: center;
  }
`;

export const ConfirmHeader = styled.h1`
  font-size: 17px;
  margin: 0;
`;

export const ConfirmTotal = styled.h1`
  color: #c82323;
  font-size: 18px;
  padding: 0 1rem;
`;

export const ConfirmBlurb = styled.p`
  color: #c82323;
  padding: 0;
  margin: 0 0 0 4rem !important;
  width: 500px;
`;

export const ConfirmGreen = styled.p`
  color: #67BE23;
  padding: 0;
  margin: 0 0 0 0rem !important;
`;

export const ConfirmRed = styled.p`
  color: #c82323;
  padding: 0;
  margin: 0 0 0 0rem !important;
`;

export const NoRecoDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
`

export const NoRecoBlurb = styled.p`
  font-size: 2rem;
  color: #c82323;
`;